import { faChartScatterBubble } from '@fortawesome/pro-regular-svg-icons'
import { useIntl } from 'react-intl'

import { FiltersButton, FiltersButtonIcon } from '../../shared/listings-ui'

/**
 * Opens the Deal Graph (GLOB-5143), a bubble plot of deal quality against
 * time-to-close, over the List View. Never persisted to the URL or grid memory
 * — the graph resets to closed on refresh/navigation, by design.
 */
export const DealGraphButton = ({
  disabled,
  onOpen,
}: {
  disabled?: boolean
  onOpen: () => void
}) => {
  const { formatMessage } = useIntl()

  return (
    <FiltersButton
      appearance="secondary"
      aria-haspopup="dialog"
      disabled={disabled}
      onClick={onOpen}
    >
      <FiltersButtonIcon icon={faChartScatterBubble} />
      <span>{formatMessage({ id: 'Listings.ListView.dealGraph.button' })}</span>
    </FiltersButton>
  )
}
